module.exports = __webpack_public_path__ + "img/product_81.0b1a694.webp";